import type { NuxtApp } from '#app'

/**
 * This composable contains global initialisations, such as session
 * restoring from cookies; and Vue Router's navigation guards.
 * Use it once and within a component that is common across all pages.
 */
export function useInitializations() {
  const { $auth, $modal, $membership }: NuxtApp = useNuxtApp()

  onBeforeMount(async () => {
    await $auth.restoreAuthState()

    if ($auth.store.isAuthenticated) {
      await $membership.loadMembershipStatuses()
    }
  })

  const router = useRouter()

  router.afterEach(() => {
    $modal.reset()
  })
}
